module.exports = __webpack_public_path__ + "img/logo.0bd2b3f2.svg";